<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        {{year}} © PDTS.
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          V0.0.0
        </div>
      </div>
    </div>
  </div>
</footer>
